import { constants } from '../../devUtils';

const SOCIAL_DATA = [
  {
    name: 'whatsapp',
    link: 'https://api.whatsapp.com/send/?phone=918367723456&text&app_absent=0',
    css: 'whatsapp',
  },
  {
    name: 'youtube',
    link: 'https://www.youtube.com/channel/UCF44bUtUAgnMNOTzyvXvkgQ?view_as=subscriber',
    css: 'youtube',
  },
  {
    name: 'instagram',
    link: 'https://www.instagram.com/zaggleapp/',
    css: 'insta',
  },
  {
    name: 'facebook',
    link: 'https://www.facebook.com/zaggleapp/',
    css: 'facebook',
  },
  // {
  //   name: 'x-twitter',
  //   link: 'https://twitter.com/zaggleapp',
  //   css: 'twitter',
  // },
  {
    name: 'linkedin',
    link: 'https://www.linkedin.com/company/zaggleapp/',
    css: 'linkedin',
  },
];

const MANIPAL_FOOTER_DESC = `<span>
&copy; @ 2019 ManipalCigna Health Insurance Company Limited. All rights reserved. Trade Name / Trade Logo belongs to MEMG International India <br />Private Limited and Cigna Intellectual Property Inc and is being used by ManipalCigna Health Insurance Company Limited under license.
<br />| CIN: U66000MH2012PLC227948 | IRDAI Reg. No.: 151 | Regd. Office: 401/ 402, 4th Floor, Raheja Titanium, <br />Off Western Express Highway, Goregaon East, Mumbai – 400 063<br />
Website: <a href=${constants.MANIPAL_CIGNA_MAIN} target="_blank">www.manipalcigna.com.</a>
</span>
`;

export { SOCIAL_DATA, MANIPAL_FOOTER_DESC };



// WEBPACK FOOTER //
// client/components/Footer/constants.js